// src/pages/markets/board/state/profileTypes.ts
import type { BodyMode, CardView } from '../board/columnConfig';

export interface ProfileColumn {
    id: string;
    // The backend column this pane queries, which the reader picks per slot.
    source: string;
    filters: Record<string, unknown>;
    layout: { body: BodyMode | null; view: CardView | null };
}

export type ProfileScope = 'user' | 'shared';

export interface ProfileRef {
    scope: ProfileScope;
    id: string;
}

export interface BoardProfile {
    id: string;
    version: number;
    name: string;
    description: string | null;
    owner_uid: string;
    scope: ProfileScope;
    promoted_from: string | null;
    created_at: string;
    updated_at: string;
    columns: ProfileColumn[];
    /** Shared profiles only: position in the global row. Absent until an admin sets one. */
    order?: number;
}

export const PROFILE_VERSION = 1;
export const MAX_USER_PROFILES = 20;
